import React, {Component} from 'react';
import config from 'react-global-configuration';
import axios from "axios";
import jwt_decode from "jwt-decode";

class Postman extends Component {
    state = {
        host: 'https://{{host}}:{{port}}/integrationserver/merchantLogin/getAuthToken',
        header: 'Content-Type: application/json',
        rawdata: ' {',
        code: '"merchantid" : "{{merchantid}}"',
        code2: '"passcode" : "{{passcode}}"',
        codeClose: '}',
        purl:'https://{{host}}:{{port}}/integrationserver/merchantLogin/getAuthToken',
        languageList:[],
        sourceCode: '',
        isDevOptionAccess: false
    }

    componentDidMount() {
        this.isValidIntegrationKey();
        this.getDevOptionsPermission();
        axios.get(config.get('API_URL') + '/diyusers/getLanguageList',
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                this.setState({
                    languageList: response.data.languages
                })
            })
            .catch(err => {
                console.log(err)
            });

             axios.post(config.get('API_URL') + '/diyusers/getCodeSinnpet',
                                    {
                                        language: 'csharp',
                                        variant: 'RestSharp',
                                        APIId: 0
                                    },
                                    {
                                        headers: {
                                            Authorization: ` ${localStorage.usertoken}`
                                        }
                                    })
                                    .then(response => {
                                       //alert(response);
                                        this.setState({
                                                   sourceCode: response.data.snippet
                                               });
                                    })
                                    .catch(err => {
                                        console.log(err)
                                        //alert(err)
                                    });

    }

    getDevOptionsPermission(){
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;

        if(AllAccessPermissions !== undefined) {
            AllAccessPermissions.map((permissionName, i) => {
                if (permissionName.access_type == 'Action' && permissionName.access_name == 'advance_developer_option') {
                    this.setState({
                        isDevOptionAccess: true
                    })
                }
            });
        }
    }

    isValidIntegrationKey(){
            axios.post(config.get('API_URL')+'/diyusers/verify-expiryDate',{},
            {
              headers: {
                Authorization: `${localStorage.usertoken}`
              }
            })
            .then(response => {
              try {
                       if (response.data.status=='expired') {
                         alert("Session Has been expired.");
                         setTimeout( function(){
                           localStorage.removeItem("usertoken");
                           window.location.href = "/";
                         }.bind(this)  , 1000 );
                        }
                        else
                        {
                            console.log(response.data);
                        }
              } catch (err) {
                console.log("expired check failed!");
              }
            })
            .catch(err => {
              console.log(err)
            })
    }


    OnLanguageChange = (e) => {
        let languageValue = e.target.value;
        if(languageValue) {
         var value = this.state.languageList.filter(function(item) {
                   return item.key == e.target.value
                })


            axios.post(config.get('API_URL') + '/diyusers/getCodeSinnpet',
                {
                    language: languageValue,
                    variant: value[0].variant,
                    APIId: 0
                },
                {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                .then(response => {
                    //alert(response);
                    this.setState({
                        sourceCode: response.data.snippet
                    });
                })
                .catch(err => {
                    console.log(err)
                    //alert(err)
                });
        }
      }

    renderInputField() {
           if(this.state.isDevOptionAccess === false) {
             return <div></div>;
           } else {
                let ltLanguage = this.state.languageList.map(data => {
                            if(data.key == 'csharp'){
                                 return <option selected value={data.key}>{data.label}</option>
                            }
                            else{
                                    return  <option value={data.key}>{data.label}</option>
                                }
                        })
             return (
                 <div className="col-md-5 pCodeBody">

                                         <label htmlFor="cars">Choose a Language :</label> &nbsp;
                                         <select id="Language" name="Language" className="langualeDrop" onChange={this.OnLanguageChange}>
                                             <option value="">Select...</option>
                                             {ltLanguage}
                                         </select>


                                         <h5 className="pCHead">Example Request</h5>
                                         <div className="pCodeBox">
                                             <div className="pcodeHead">
                                                 getAuthToken
                                             </div>
                                             <div className="pcodeB">
                                                <pre>
                                                    <code>
                                                         {this.state.sourceCode}
                                                    </code>
                                                </pre>

                                             </div>
                                         </div>
                                     </div>
             );
           }
         }

    render() {

        return (
            <div>

                   <div className="col-md-7 leftBody">
                       <br />
                        <span className="post">POST</span> <span className="postHead"> getAuthToken</span>
                        <br />
                       <br />
                        <span className="pUrl"> {this.state.purl} </span>
                        <br />
                       <br />
                        <p className="diyJustify">
                            This API will be used for authentication purpose. Innoviti will provide a valid login credential (merchant id and passcode). Merchant Billing Server will require this authentication token generated by the login for the further communication with Innoviti Integration Server. New token would be generated for each login attempt.
                        </p>

                       {/*<h6 className="postHead">Mandatory request parameters, </h6>*/}
                       <h6 className="diyTableBorFont ma">MANDATORY REQUEST PARAMETERS </h6>
                       <hr className="hrDiv" />
                        <table className="table-bordered diyTableBorFont">
                            <thead>
                            <tr>
                                <th className="diyTableBorFont p-l-5">Parameter</th>
                                <th className="diyTableBorFont p-l-5">Type</th>
                                <th className="diyTableBorFont p-l-5">Description</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>merchantid</td>
                                <td>String</td>
                                <td>data will be provided by Innoviti</td>
                            </tr>
                            <tr>
                                <td>passcode</td>
                                <td>String</td>
                                <td>data will be provided by Innoviti</td>
                            </tr>
                            </tbody>
                        </table>
<br />
                       <h6 className="diyTableBorFont"> HEADERS</h6>
                        <hr className="hrDiv" />
                       <small>Content-Type &nbsp;&nbsp;&nbsp;&nbsp;application/json</small>
<br />
<br />
                        <h6>BODY raw </h6>
                        <hr className="hrDiv" />
                        <span className="pUrlBody">

                             <br/>
                                        <span > {this.state.rawdata} </span>
                                        <br/><br/>
                                       <span> {this.state.code} </span><span >,</span>
                                       <br/>
                                        <span> {this.state.code2} </span>
                                       <br/><br/>
                                       <span > {this.state.codeClose}</span>
                            <br />
                        </span>
                    </div>
                        {this.renderInputField()}


            </div>

        );
    }
}

export default Postman;